import { actionFailure } from 'src/modules/assistant/actions/createActionHandler';
import {
    TActionStrategy,
    TSendTemplateDraft,
} from 'src/modules/assistant/actions/types';
import { buildChannelTarget } from 'src/modules/assistant/actions/helpers/buildChannelTarget';
import { toChannelSendError } from 'src/modules/assistant/actions/helpers/channelSendErrors';
import { buildLeadTemplateSend } from './buildLeadTemplateSend';

/**
 * `channels` areas: sends the template on the lead's `WarboxConversation`
 * (`/conversations/sendTemplate`), which the backend creates when the lead has none.
 * Templates do not need an inbound message or an open 24 h window.
 */
export const sendChannelTemplate: TActionStrategy<TSendTemplateDraft> = async (
    draft,
    deps
) => {
    const payload = await buildLeadTemplateSend(draft, deps);
    if (!payload) return false;
    const { conversation, sendTemplate } = deps.channelMessaging;
    const target = buildChannelTarget(deps.lead, deps.channel, conversation);

    try {
        await sendTemplate({
            ...target,
            _id: payload._id,
            message: payload.message,
            body: payload.body,
            templateTitle: payload.templateTitle,
            templateType: payload.templateType,
            messageWithoutFormat: payload.messageWithoutFormat,
            options: payload.options,
            contentSid: payload.contentSid,
            contentTemplateBuilder: payload.contentTemplateBuilder,
            language: payload.language,
            by: payload.by,
            author: payload.by?.name,
            isAssistantGenerated: true,
        });
        return true;
    } catch (error) {
        return actionFailure(toChannelSendError(error));
    }
};
